/* tslint:disable */
/* eslint-disable */
/**
 * Indices API
 * Référentiel des indices de branche et de leurs valeurs datées
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Recherche paginée dans le référentiel des indices.
 * @export
 * @interface SearchIndicesCommand
 */
export interface SearchIndicesCommand {
    /**
     * 
     * @type {string}
     * @memberof SearchIndicesCommand
     */
    branchId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchIndicesCommand
     */
    searchString?: string | null;
    /**
     * Ne remonte que les indices rattachés à aucune branche.
     * @type {boolean}
     * @memberof SearchIndicesCommand
     */
    unassignedOnly?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SearchIndicesCommand
     */
    pageNumber?: number;
    /**
     * Borné à 200 par le back.
     * @type {number}
     * @memberof SearchIndicesCommand
     */
    pageSize?: number;
}

/**
 * Check if a given object implements the SearchIndicesCommand interface.
 */
export function instanceOfSearchIndicesCommand(value: object): value is SearchIndicesCommand {
    return true;
}

export function SearchIndicesCommandFromJSON(json: any): SearchIndicesCommand {
    return SearchIndicesCommandFromJSONTyped(json, false);
}

export function SearchIndicesCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchIndicesCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'branchId': json['branchId'] == null ? undefined : json['branchId'],
        'searchString': json['searchString'] == null ? undefined : json['searchString'],
        'unassignedOnly': json['unassignedOnly'] == null ? undefined : json['unassignedOnly'],
        'pageNumber': json['pageNumber'] == null ? undefined : json['pageNumber'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function SearchIndicesCommandToJSON(json: any): SearchIndicesCommand {
    return SearchIndicesCommandToJSONTyped(json, false);
}

export function SearchIndicesCommandToJSONTyped(value?: SearchIndicesCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'branchId': value['branchId'],
        'searchString': value['searchString'],
        'unassignedOnly': value['unassignedOnly'],
        'pageNumber': value['pageNumber'],
        'pageSize': value['pageSize'],
    };
}

